// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Eodc","fullView":"styles_fullView__10nc6"};